import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { HttpHeaders } from '@angular/common/http';
import { ResponseUtils } from '../response-utils';

export const kymw06Handlers = [
  // 対象関連Pコード商品情報取得 /kymw06/getTargetRelationPcodeGoodsInfo
  http.post(PlessService.SERVICE.getTargetRelationPcodeGoodsInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.getRequestListInfo.url, req);
    return HttpResponse.json(getTargetRelationPcodeGoodsInfoResponse);
    // return HttpResponse.json(getRequestListInfoResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // 候補一覧情報取得 /kymw06/getCandidateListInfo
  http.post(PlessService.SERVICE.KYMW0600getCandidateListInfo.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.KYMW0600getCandidateListInfo.url, req);
    return HttpResponse.json(getCandidateListInfoResponse);
    // return HttpResponse.json(getRequestListInfoResponseEmpty);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
  // 関連Pコード更新 /kymw06/updateRelationPcode
  http.post(PlessService.SERVICE.updateRelationPcode.url, async ({ request }) => {
    const req = await request.json();
    console.log(PlessService.SERVICE.updateRelationPcode.url, req);
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const getTargetRelationPcodeGoodsInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "PCode": "P2670878",
        "GuideGoodsName": "３種の海鮮丼（まぐろ・めかぶ・紅鮭いくら）",
        "GuideStandardName": "１００ｇ（５０ｇ×２）",
        "MakerName": "山菱水産",
        "PayeeClientCode": "933880",
        "SupplierNameKanji": "山菱水産",
        "RegularRegistDate": "2023年03月08日",
        "RelationPCodeOld": "P0001091",
        "RelationPCodeNew": "P0001082",
        "GroupId": "27",
        "ApplyTermEnd": "99999999"
      },
      {
        "PCode": "P0001082",
        "GuideGoodsName": "青首大根",
        "GuideStandardName": "１本",
        "MakerName": "",
        "PayeeClientCode": "947385",
        "SupplierNameKanji": "コープネット農産",
        "RegularRegistDate": "1995年12月01日",
        "RelationPCodeOld": "P2670878",
        "RelationPCodeNew": "",
        "GroupId": "27",
        "ApplyTermEnd": "99999999"
      },
      {
        "PCode": "P0001091",
        "GuideGoodsName": "青首大根（カット）",
        "GuideStandardName": "１本分（１／２カット）",
        "MakerName": "",
        "PayeeClientCode": "947385",
        "SupplierNameKanji": "コープネット農産",
        "RegularRegistDate": "1995年12月01日",
        "RelationPCodeOld": "",
        "RelationPCodeNew": "P2670878",
        "GroupId": "27",
        "ApplyTermEnd": "99999999"
      },
      // {
      //   "Pcode": "P9999998",
      //   "GuideGoodsName": "（旧）商品案内用商品名",
      //   "GuideStandardName": "（旧）商品案内用規格名",
      //   "MakerName": "メーカー名",
      //   "PayeeClientCode": "999999",
      //   "SupplierNameKanji": "取引先名称(漢字)",
      //   "RegularRegistDate": "YYYY年MM月DD日",
      //   "RelationPcodeOld": "",
      //   "RelationPcodeNew": "",
      //   "GroupId": "1",
      //   "ApplyTermEnd": "20251218",
      // },
    ],
  },
};

const getCandidateListInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: [
      {
        "Pcode": "P0000302",
        "GuideGoodsName": "商品案内用商品名1",
        "GuideStandardName": "商品案内用規格名1",
        "MakerName": "メーカー名1",
        "PayeeClientCode": "999999",
        "SupplierNameKanji": "取引先名称(漢字)",
        "RegularRegistDate": "YYYY年MM月DD日",
        "RelationPcodeOld": "P0000303",
        "RelationPcodeNew": "P0000304",
        "GroupId": "1",
        "ApplyTermEnd": "20251218",
      },
      {
        "Pcode": "P0000402",
        "GuideGoodsName": "商品案内用商品名2",
        "GuideStandardName": "商品案内用規格名2",
        "MakerName": "メーカー名2",
        "PayeeClientCode": "999999",
        "SupplierNameKanji": "取引先名称(漢字)",
        "RegularRegistDate": "YYYY年MM月DD日",
        "RelationPcodeOld": "P0000403",
        "RelationPcodeNew": "P0000404",
        "GroupId": "1",
        "ApplyTermEnd": "20251218",
      },
      {
        "Pcode": "P0000502",
        "GuideGoodsName": "商品案内用商品名3",
        "GuideStandardName": "商品案内用規格名3",
        "MakerName": "メーカー名3",
        "PayeeClientCode": "999999",
        "SupplierNameKanji": "取引先名称(漢字)",
        "RegularRegistDate": "YYYY年MM月DD日",
        "RelationPcodeOld": "P0000503",
        "RelationPcodeNew": "P0000504",
        "GroupId": "1",
        "ApplyTermEnd": "20251218",
      },
      {
        "Pcode": "P0000602",
        "GuideGoodsName": "商品案内用商品名4",
        "GuideStandardName": "商品案内用規格名4",
        "MakerName": "メーカー名4",
        "PayeeClientCode": "999999",
        "SupplierNameKanji": "取引先名称(漢字)",
        "RegularRegistDate": "YYYY年MM月DD日",
        "RelationPcodeOld": "P0000603",
        "RelationPcodeNew": "P0000604",
        "GroupId": "1",
        "ApplyTermEnd": "20251218",
      },
      {
        "Pcode": "P0000702",
        "GuideGoodsName": "旧商品",
        "GuideStandardName": "商品案内用規格名5",
        "MakerName": "メーカー名3",
        "PayeeClientCode": "999999",
        "SupplierNameKanji": "取引先名称(漢字)",
        "RegularRegistDate": "YYYY年MM月DD日",
        "RelationPcodeOld": "P0000703",
        "RelationPcodeNew": "P0000704",
        "GroupId": "1",
        "ApplyTermEnd": "20250118",
      },
    ],
  },
};
